import * as React from 'react';
import {StackActions, CommonActions} from '@react-navigation/native';

export const navigationRef = React.createRef();

export function navigate(name, params) {
    console.log(navigationRef);
    navigationRef.current?.navigate(name, params);
}

export function navigateParams(name, params) {

    navigationRef.current?.navigate(name, params);
}

export function replace(name, params) {

    // const resetAction = StackActions.reset({
    //     index: 0,
    //     actions: [NavigationActions.navigate({ routeName: 'MainActivity' })],
    // });
    //
    // this.props.navigation.dispatch(resetAction);
    //  navigationRef.current?.reset(name);
    // navigationRef.current?.replace({
    //     index: 0,
    //     routes: [{
    //         name: name, params: params,
    //     }]
    // })

    //navigationRef.current?.replace(name, params)
    navigationRef.current.dispatch(StackActions.replace(name, params));
}

export function navigatereset(name, params) {
    navigationRef.current?.reset(name, params);
}

export function resetTo(name, params) {

    try {
        navigationRef.current?.reset({
            index: 0,
            routes: [{name: name}],
        });
    }
    catch (e) {
        try {
            navigationRef.current?.reset(name, params);
        }
        catch (e) {
            console.log(e);
        }
    }

    //  navigationRef.current?.reset(name, params);
}

export function BackTo(n) {
    const popAction = StackActions.pop(n);

    navigationRef.current.dispatch(popAction);
    // navigationRef.current?.goBack(n);
    //  navigationRef.current?.pop(n);
    //   navigationRef.current?.dispatch(StackActions.pop({n: n}))
}

export function navigateKeyDynamic(name, params) {
//    const popAction = StackActions.pop(n);

    navigationRef.current.dispatch(
        CommonActions.navigate({
            name: name,
            params: params,
            key: Math.floor(Math.random() * 100),
        }),
    );
    // navigationRef.current?.goBack(n);
    //  navigationRef.current?.pop(n);
    //   navigationRef.current?.dispatch(StackActions.pop({n: n}))
}

export function PopToPop(params) {

    //navigationRef.current?.goBack(params);
    navigationRef.current?.dispatch(StackActions.popToTop());

}


export function Pop() {
    navigationRef.current?.goBack();
}


//import {NavigationActions, StackActions} from 'react-navigation';
/*
import {CommonActions} from '@react-navigation/native';

let _navigator;

function setTopLevelNavigator(navigatorRef) {
    _navigator = navigatorRef;
}

function navigate(routeName) {
    _navigator.dispatch(
        CommonActions.navigate({
            routeName
        })
    );
}

function navigateParams(routeName, params) {
    _navigator.dispatch(
        CommonActions.navigate({
            routeName,
            params,
            // transition: 'collapseExpand'

        })
    );
}

function navigatereset(routeName, params) {
    _navigator.dispatch(
        CommonActions.reset({
            index: 0,
            actions: [
                CommonActions.navigate({routeName: routeName, params}),
            ],
        })
    );

}

function resetTo(route, params) {

    _navigator.dispatch(CommonActions.reset({
        index: 0,
        key: null,
        actions: [CommonActions.navigate({routeName: route, params})],
    }));
}

function BackTo(n) {
    _navigator.dispatch(CommonActions.pop({n: n}))

}

function PopToPop() {

    _navigator.dispatch(CommonActions.popToTop());
}

function Pop() {

    _navigator.dispatch(CommonActions.pop());
}

function replace(route, params) {
    _navigator.dispatch(CommonActions.replace({routeName: route, params}))

}

function pop() {

    _navigator.dispatch(CommonActions.back())
    // _navigator.dispatch(CommonActions.pop({
    //    n: 1,
    //  }));
    //  _navigator.dispatch(CommonActions.back());
    //_navigator.dispatch((CommonActions.back()));
    // _navigator.dispatch(CommonActions.back({key: null}));
    //_navigator.dispatch(CommonActions.goBack(null));
    // _navigator.navigation.goBack(null);
    //_navigator.navigation.pop();
    // _navigator.dispatch(CommonActions.reset({
    //     index: 0,
    //     key: null,
    //     actions: [CommonActions.back()],
    // }));
}

// function resetToAll(route) {
//     const actionToDispatch = CommonActions.reset({
//         index: 0,
//         actions: [CommonActions.navigate({ routeName: route })],
//     });
//     _navigator.dispatch(actionToDispatch);
// }
// add other navigation functions that you need and export them

export default {
    navigate,
    setTopLevelNavigator,
    navigateParams,
    navigatereset,
    resetTo,
    pop,
    BackTo,
    PopToPop,
    Pop,
    replace,

};
*/
